import { z } from 'zod';

export const SNAPSHOT_TTL_MS = 14 * 24 * 60 * 60 * 1000; // two weeks

/** Attribution bag, analytics only. Open map so any `sc_*`/`utm_*` key survives. */
const trackingSchema = z.record(z.string(), z.string());

/**
 * Persisted snapshot: an injected, journey-specific payload plus attribution and
 * a capture timestamp. The payload shape is the consumer's (a booking intent, a
 * feature-trial ref, ...); the envelope around it is generic.
 */
export interface JourneySnapshot<T> {
  payload: T;
  tracking: Record<string, string>;
  createdAt: number; // epoch ms, drives expiry
}

/** Envelope validator for a given payload schema, used to parse what storage returns. */
export function journeySnapshotSchema<T>(payload: z.ZodType<T>) {
  return z.object({
    payload,
    tracking: trackingSchema,
    createdAt: z.number(),
  });
}
